module.exports = __webpack_public_path__ + "img/banner_1979.254d954e.png";